// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// TODO: Replace with your actual Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyBvzcOtuB6eOtZVxC01PO9Ahd6DdISsEss",
  authDomain: "love-light-controller.firebaseapp.com",
  projectId: "love-light-controller",
  storageBucket: "love-light-controller.firebasestorage.app",
  messagingSenderId: "894715584060",
  appId: "1:894715584060:web:d5f90c7cfcf9b496326d39",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get Firestore instance
const db = getFirestore(app);

export { db }; // Export the Firestore instance
